export const GET_REGISTRATION_REPORT_EXAM_LEVEL =
  '/candidate/api/exam-registrations/registration-report/filter';

export const POST_GENERATE_REPORT = '/registration-report/export';

export const GET_NON_NATIONAL_EXAM_LIST =
  '/candidate/api/non-national-exam-registrations/registration-report/filter';
